import { topRank } from "@/mocks/home";

export default function TopRank() {
  return (
    <section id="top" className="relative w-full bg-background-900/60 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <span className="text-sm tracking-widest text-accent-400">TOP RANKING</span>
          <h2 className="mt-2 font-heading text-3xl text-foreground-50 md:text-4xl">口碑高分榜</h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-foreground-400">
            经时间检验、观众一致好评的优质作品，是绕开烂番、直奔经典的可靠参考。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-6">
          {topRank.map((item, idx) => (
            <article
              key={item.id}
              className="group relative overflow-hidden rounded-lg border border-background-800/70 bg-background-900 transition-colors hover:border-accent-500/60"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title} 动漫海报`}
                  title={item.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <span className="absolute left-2 top-2 flex h-8 w-8 items-center justify-center rounded bg-accent-500 font-heading text-lg text-background-50">
                  {idx + 1}
                </span>
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-background-950/90 to-transparent p-3">
                  <p className="flex flex-wrap gap-1">
                    {item.tags.map((t) => (
                      <span key={t} className="rounded bg-background-950/60 px-1.5 py-0.5 text-[10px] text-accent-300">
                        {t}
                      </span>
                    ))}
                  </p>
                </div>
              </div>
              <div className="flex items-center justify-between gap-2 p-3">
                <h3 className="truncate text-sm font-medium text-foreground-100">{item.title}</h3>
                <span className="shrink-0 font-heading text-lg text-accent-400">{item.score.toFixed(1)}</span>
              </div>
              <p className="px-3 pb-3 text-xs leading-relaxed text-foreground-400">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}